import Vue from 'vue';

import { mountVue } from './utils/vueContainer';

// All Vue components
import Newsletter from './components/Newsletter';
import CollapseItem from './components/CollapseItem';
import TwitchStream from './components/TwitchStream';

// ------------------------------------------------------------------------
// Boot App
// ------------------------------------------------------------------------
require('./boot');

// ------------------------------------------------------------------------
// Register Vue Components
// ------------------------------------------------------------------------
Vue.component('newsletter', Newsletter);
Vue.component('collapseitem', CollapseItem);
Vue.component('twitch-stream', TwitchStream);

// ------------------------------------------------------------------------
// Mount Vue Instances (outside of Barba container)
// ------------------------------------------------------------------------
mountVue('.js-vueContainer', document);

// ------------------------------------------------------------------------
// Triggers once the app has been launched
// ------------------------------------------------------------------------
document.addEventListener('AppReady', () => {
    document.documentElement.classList.remove('no-fouc');
});

// ------------------------------------------------------------------------
// Launch the app
// ------------------------------------------------------------------------
if (document.readyState === 'complete') {
    document.dispatchEvent(new CustomEvent('AppReady'));
} else {
    document.addEventListener('DOMContentLoaded', () => document.dispatchEvent(new CustomEvent('AppReady')));
}
